<script setup lang="ts"></script>

<template>
	<svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.5002 2.33331C8.07183 2.33331 2.8335 7.57165 2.8335 14C2.8335 20.4283 8.07183 25.6666 14.5002 25.6666C20.9285 25.6666 26.1668 20.4283 26.1668 14C26.1668 7.57165 20.9285 2.33331 14.5002 2.33331ZM20.0768 11.3166L13.4618 17.9316C13.2978 18.0955 13.0754 18.1875 12.8435 18.1875C12.6116 18.1875 12.3892 18.0955 12.2252 17.9316L8.9235 14.63C8.76077 14.4653 8.66951 14.2431 8.66951 14.0116C8.66951 13.7801 8.76077 13.558 8.9235 13.3933C9.26183 13.055 9.82183 13.055 10.1602 13.3933L12.8435 16.0766L18.8402 10.08C19.1785 9.74165 19.7385 9.74165 20.0768 10.08C20.4152 10.4183 20.4152 10.9666 20.0768 11.3166Z"
			fill="#36A669"
		/>
	</svg>
</template>
